import { useEffect, useState } from "react";
import { springs, toCssTransition } from "../../config/springs";
export type DrawPathProps = {
  d: string;
  /** The path's drawn length; the stroke reveals over it. */
  length: number;
  stroke: string;
  strokeWidth: number;
};
const draw = toCssTransition(springs.draw);

/** A stroke that draws itself in from its start on mount. */
export function DrawPath({
  d,
  length,
  stroke,
  strokeWidth
}: DrawPathProps) {
  const [drawn, setDrawn] = useState(false);
  useEffect(() => {
    const frame = requestAnimationFrame(() => setDrawn(true));
    return () => cancelAnimationFrame(frame);
  }, []);
  return <path d={d} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" strokeDasharray={length} style={{
    strokeDashoffset: drawn ? 0 : length,
    transition: `stroke-dashoffset ${draw}`
  }} data-sentry-element="path" data-sentry-component="DrawPath" data-sentry-source-file="DrawPath.tsx" />;
}
const fillIn = toCssTransition(springs.draw);

/** A filled shape that fades in on mount. */
export function FadeInPath({
  d,
  fill
}: {
  d: string;
  fill: string;
}) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const frame = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(frame);
  }, []);
  return <path d={d} fill={fill} style={{
    opacity: shown ? 1 : 0,
    transition: `opacity ${fillIn}`
  }} data-sentry-element="path" data-sentry-component="FadeInPath" data-sentry-source-file="DrawPath.tsx" />;
}